<section
  *ngIf="isWrapped"
  class="t-widget--noBottomPad"
  [ngClass]="wrapperClass"
>
  <ng-container *ngTemplateOutlet="uiTableStructure"></ng-container>
</section>

<ng-container *ngIf="!isWrapped"
  ><ng-container *ngTemplateOutlet="uiTableStructure"></ng-container
></ng-container>

<ng-template #uiTableStructure>
  <header *ngIf="title || topEnd" class="l-flex-column">
    <div class="l-align-spaceBetween">
      <h2 *ngIf="title" class="t-widgetTitle">
        {{ title | translate }}
      </h2>
      <ng-container *ngTemplateOutlet="topEnd"></ng-container>
    </div>

    <hr *ngIf="title" />
  </header>

  <ng-container *ngTemplateOutlet="belowTitle"></ng-container>
  <hr *ngIf="belowTitle" />

  <loader *ngIf="_data && _data.loading"></loader>

  <div *ngIf="_data && _data.sorry" class="t-alert-info" role="alert">
    {{ "translate.alert.noResults" | translate }}
  </div>
  <!-- 
  [paginator]="
  showPaginator &&
  (totalRecords > numberOfRows || _data.length > numberOfRows)
" -->

  <p-table
    #uiTable
    [value]="_data"
    *ngIf="_data"
    class="iscs-table iscs-table-auto"
    [class.dense]="dense"
    [class.tbl-color]="tblColor"
    [class.tbl-round-bottom]="tblRoundBottom"
    [paginator]="showPaginator"
    [rows]="numberOfRows"
    [first]="first"
    [lazy]="!!totalRecords"
    (onLazyLoad)="outputPaginationData($event)"
    [ngClass]="{ 'is-loading': _data.loading }"
    [sortField]="orderBy"
    [sortOrder]="sortOrder"
    [scrollable]="scrollable"
    [scrollHeight]="scrollHeight"
    (onPage)="onPagination()"
    [showCurrentPageReport]="paginatorTxt"
    [paginatorPosition]="paginatorPosition"
    currentPageReportTemplate=" {{
      (totalRecords == 1000
        ? 'translate.general.tblCurPageDisplayMax'
        : 'translate.general.tblCurPageDisplay'
      ) | translate
    }}"
  >
    <ng-template pTemplate="header">
      <ng-container *ngIf="showHeaders">
        <ng-container *ngTemplateOutlet="aboveTableHeader"></ng-container>

        <tr>
          <th *ngIf="checkRows" class="cell-moreInfo">
            <checkbox-wrap>
              <input
                type="checkbox"
                [(ngModel)]="toggleAllSw"
                (ngModelChange)="onToggleAll()"
              />
            </checkbox-wrap>
          </th>

          <th
            *ngIf="templateFirstCol"
            [ngClass]="templateFirstCol.colClass"
          >
            <div *ngIf="templateFirstCol.titleTemplate">
              <ng-container
                *ngTemplateOutlet="templateFirstCol.titleTemplate"
              ></ng-container>
            </div>
            <div *ngIf="templateFirstCol.title">
              {{ templateFirstCol.title }}
            </div>
          </th>

          <ng-container *ngIf="prepend">
            <th
              *ngFor="let template of templatesFiltered"
              [ngClass]="template.colClass"
            >
              {{ template.title | translate }}
            </th>
          </ng-container>

          <ng-container *ngFor="let th of displayFilter; let i = index">
            <th class="cell-{{ th }}" [ngClass]="colSetsForFilter[i]?.colClass">
              <!-- clickable th ( start )-->
              <button
                *ngIf="sortable"
                (click)="onSort(th, i, $event, false)"
                [ngClass]="{ 'is-active': i === currentClickableTy }"
                class="t-clickableTh"
              >
                <span class="l-align-y">
                  {{ "translate.general." + th | translate }}
                  <i class="t-clickableTh-icon fas fa-long-arrow-alt-up"></i>
                </span>
              </button>
              <!-- clickable th ( end) -->
              <ng-container *ngIf="!sortable">{{
                "translate.general." + th | translate
              }}</ng-container>
            </th>

            <ng-container *ngIf="templateAtCol[i]">
              <th>
                <div *ngIf="templateAtCol[i].titleTemplate">
                  <ng-container
                    *ngTemplateOutlet="templateAtCol[i].titleTemplate"
                  ></ng-container>
                </div>
                <div *ngIf="templateAtCol[i].title">
                  {{ templateAtCol[i].title | translate }}
                </div>
              </th>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="!prepend">
            <th
              *ngFor="let template of templatesFiltered; let j = index"
              [ngClass]="template.colClass"
            >
              <button
                *ngIf="sortable"
                (click)="onSort(template, j, $event, true)"
                [ngClass]="{ 'is-active': j === currentClickableTemplate }"
                class="t-clickableTh"
              >
                <span class="l-align-y">
                  {{ template.title | translate }}
                  <i class="t-clickableTh-icon fas fa-long-arrow-alt-up"></i>
                </span>
              </button>

              <!--normal template -->
              <ng-container *ngIf="!sortable">
                <div *ngIf="template.titleTemplate">
                  <ng-container
                    *ngTemplateOutlet="template.titleTemplate"
                  ></ng-container>
                </div>
                <div *ngIf="template.title">
                  {{ template.title | translate }}
                </div>
              </ng-container>
            </th>
          </ng-container>

          <th *ngIf="more" class="cell-moreInfo"></th>
        </tr>
      </ng-container>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr
        (click)="rowSelected(row)"
        [class.t-hover-tr]="rowHover && highlightOnHover"
        [class.t-pointer]="true"
        [ngClass]="{ 'bg-success': highlightRow(row) }"
        [class.rowC1]="row.rowC1"
        [class.rowCWarn]="row.rowCWarn"
        [class.rowGrey]="row.rowGrey"
        [class.rowWhite]="!row.rowC1 && !row.rowCWarn && !row.rowGrey"
      >
        <!-- checkbox (start) -->
        <td *ngIf="checkRows" class="l-ta-center">
          <checkbox-wrap *ngIf="row.editableSw != false">
            <input
              type="checkbox"
              [(ngModel)]="row.selected"
              (ngModelChange)="onRowCheck(row)"
            />
          </checkbox-wrap>
        </td>
        <!-- checkbox (end) -->

        <!-- custom cell with specified column choice: first (start) -->
        <ng-container *ngIf="templateFirstCol">
          <td [ngClass]="templateFirstCol.colClass">
            <ng-container
              *ngTemplateOutlet="
                templateFirstCol.template;
                context: { row: row }
              "
            ></ng-container>
          </td>
        </ng-container>
        <!-- custom cell with specified column choice: first (end) -->

        <!-- custom cells (start) -->
        <ng-container *ngIf="prepend">
          <td
            *ngFor="let template of templatesFiltered"
            [ngClass]="template.colClass"
          >
            <ng-container
              *ngTemplateOutlet="template.template; context: { row: row }"
            ></ng-container>
          </td>
        </ng-container>
        <!-- custom cells (end) -->

        <ng-container *ngFor="let td of displayFilter; let i = index">
          <td [ngClass]="colSetsForFilter[i]?.colClass" [ngSwitch]="cellType(row[td])">
            <ng-container *ngSwitchCase="'bool'">
              <div
                *ngIf="row[td]"
                class="w-full l-ta-center fas fa-{{ isTrueIcon }} c1"
              ></div>
              <div
                *ngIf="!row[td]"
                class="w-full l-ta-center fas fa-{{ isFalseIcon }}"
              ></div>
            </ng-container>

            <ng-container *ngSwitchCase="'image'">
              <figure class="t-frame--100">
                <img [attr.src]="row[td]" alt="" />
              </figure>
            </ng-container>

            <ng-container *ngSwitchCase="'string'">
              {{ row[td] }}
            </ng-container>

            <ng-container *ngSwitchCase="'dataElement'">
              {{ row[td].text }}
            </ng-container>

            <ng-container *ngSwitchCase="'uiUser'">
              {{ row[td].userDescr }}
            </ng-container>

            <ng-container *ngSwitchCase="'date'">
              {{ row[td] | date : "dd/MM/yy" }}
            </ng-container>

            <ng-container *ngSwitchCase="'translatable'">
              {{ row[td] | translate }}
            </ng-container>
          </td>
          <!-- custom cell with specified column choice (start) -->
          <ng-container *ngIf="templateAtCol[i]">
            <td [ngClass]="templateAtCol[i].colClass">
              <ng-container
                *ngTemplateOutlet="
                  templateAtCol[i].template;
                  context: { row: row }
                "
              ></ng-container>
            </td>
          </ng-container>
          <!-- custom cell with specified column choice (end) -->
        </ng-container>

        <!-- custom cells (start) -->
        <ng-container *ngIf="!prepend">
          <td
            *ngFor="let template of templatesFiltered"
            [ngClass]="template.colClass"
          >
            <ng-container
              *ngTemplateOutlet="template.template; context: { row: row }"
            ></ng-container>
          </td>
        </ng-container>
        <!-- custom cells (end) -->

        <!-- show more button (start) -->
        <td *ngIf="more" class="l-ta-center">
          <button
            [ngClass]="{ 'is-open': isInOpenCache(row) }"
            class="t-button t-button--pill t-btn-more bg-white"
            (click)="toggleShowMore(row, $event)"
          >
            <i class="fas t-tr-arrow"></i>
          </button>
        </td>
        <!-- show more button (end) -->
      </tr>

      <!-- extra content hidden by default (start) -->
      <tr *ngIf="more && isInOpenCache(row)">
        <td [attr.colspan]="colSpan" class="t-pad-0">
          <div class="t-pad--med t-table-showMore">
            <ng-container
              *ngTemplateOutlet="more; context: { row: row }"
            ></ng-container>
          </div>
        </td>
      </tr>
      <!-- extra content hidden by default (end) -->
    </ng-template>

    <ng-template pTemplate="footer" let-columns>
      <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
    </ng-template>
  </p-table>
</ng-template>

<ng-template #moreItems let-row="row">
  <div [@delayLeave] class="t-pad--med t-table-showMore">
    <ng-container
      *ngTemplateOutlet="more; context: { row: row }"
    ></ng-container>
  </div>
</ng-template>
